import { nav } from './it/nav';
import { home } from './it/home';
import { vps } from './it/vps';
import { dedicated } from './it/dedicated';
import { gameHosting } from './it/gameHosting';
import { webHosting } from './it/webHosting';
import { ipTransit } from './it/ipTransit';
import { colocation } from './it/colocation';
import { network } from './it/network';
import { contact } from './it/contact';
import { common } from './it/common';
import { legal } from './it/legal';
import { faq } from './it/faq';
import { datacenters } from './it/datacenters';
import { abuse } from './it/abuse';

export const it = {
  nav,
  home,
  vps,
  dedicated,
  gameHosting,
  webHosting,
  ipTransit,
  colocation,
  network,
  contact,
  common,
  legal,
  faq,
  datacenters,
  abuse
};